import { standardApiHandler } from "../../../core/core-api/apiTools";
import { getDataSetFilterByIdAdapter } from "./getDataSetFilterById.adapter";
import { GetDataSetFilterByIdServiceParams } from "./types";
import { Filter } from "../../../filter/types";

export type GetDataSetFilterByIdService = (params: GetDataSetFilterByIdServiceParams) => Promise<Filter>;
export const getDataSetFilterByIdService: GetDataSetFilterByIdService = standardApiHandler(getDataSetFilterByIdAdapter);
